/**
 * Server prose when there is any, else the surface's own wording. One owner, so
 * a refused write and a refused read explain themselves the same way.
 */
export const noticeForError = (
  errorMessage: string | null | undefined,
  fallback: string,
): string => (errorMessage?.trim() ? errorMessage : fallback);
